import type { StateCreator } from 'zustand';

/**
 * UI Slice - Gestion de l'état UI (modals, sidebar, mobile menu)
 */
export interface UiSlice {
  // Modals
  openModals: string[];
  openModal: (id: string) => void;
  closeModal: (id: string) => void;
  closeAllModals: () => void;
  isModalOpen: (id: string) => boolean;

  // Sidebar
  sidebarExpanded: boolean;
  toggleSidebar: () => void;
  setSidebarExpanded: (expanded: boolean) => void;

  // Mobile menu
  mobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
  setMobileMenuOpen: (open: boolean) => void;
}

export const createUiSlice: StateCreator<UiSlice> = (set, get) => ({
  // Modals
  openModals: [],

  openModal: (id) =>
    set((state) => ({
      openModals: state.openModals.includes(id)
        ? state.openModals
        : [...state.openModals, id],
    })),

  closeModal: (id) =>
    set((state) => ({
      openModals: state.openModals.filter((modalId) => modalId !== id),
    })),

  closeAllModals: () => set({ openModals: [] }),

  isModalOpen: (id) => get().openModals.includes(id),

  // Sidebar
  sidebarExpanded: true,

  toggleSidebar: () =>
    set((state) => ({ sidebarExpanded: !state.sidebarExpanded })),

  setSidebarExpanded: (expanded) => set({ sidebarExpanded: expanded }),

  // Mobile menu
  mobileMenuOpen: false,

  toggleMobileMenu: () =>
    set((state) => ({ mobileMenuOpen: !state.mobileMenuOpen })),

  setMobileMenuOpen: (open) => set({ mobileMenuOpen: open }),
});
